module.exports = __webpack_public_path__ + "img/SES_CS-SLIMLINER-User.2129e65b.jpg";